import { DataTable } from './DataTable'
import { Button } from 'antd'
import { YhBox } from '@/components/YhBox'
import { baseCompanyModel } from '../companyModel'
import { BankOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { setAddCarVisible } = baseCompanyModel()

    const action = (
        <>
            <Button shape="round" type="primary" onClick={() => setAddCarVisible(true)}>
                <BankOutlined />
                添加产权归属公司
            </Button>
            {/* <Button shape="round" onClick={() => {
        if(!selectedRowKeys.length){
            return message.warning('请选择产权归属公司进行删除功能！')
        }else{
            onDelete(selectedRowKeys)}}}><DeleteOutlined />一键删除</Button> */}
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
